import { differenceInMilliseconds, parseISO } from "date-fns";
import type { Task } from "src/queries/tasks/tasks.types";

export const filterOptions = (
  options: Task[],
  { inputValue }: { inputValue: string }
) =>
  options.filter((option) =>
    option.task_name.toLowerCase().includes(inputValue.toLowerCase())
  );

export const isOptionEqualToValue = (option: Task, value: Task) =>
  +option.task_id === +value.task_id;

// task comes in the form of a string: "name-id"
export const parseTask = (task: string | undefined) =>
  task?.split(/-(?=[^-]+$)/) ?? [];

export const getTaskRunsDetails = (tasks?: Task[]) => {
  if (!tasks) {
    return { minStartTime: 0, totalDuration: 0 };
  }

  const allStartTimes = tasks.map((t) => parseISO(t.start_time));
  const allEndTimes = tasks.map((t) => {
    if (!t.end_time) {
      return new Date();
    }

    return parseISO(t.end_time);
  });

  const minStartTime = Math.min(...allStartTimes.map((d) => d.getTime()));
  const maxEndTime = Math.max(...allEndTimes.map((d) => d.getTime()));
  const totalDuration = differenceInMilliseconds(maxEndTime, minStartTime);

  return { minStartTime, totalDuration };
};
